import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .then((ref) => {
    /*console.warn(
      'Angular app is bootstrapped and time is ',
      new Date().getTime() - start
    );*/
    if (environment.production) {
      appendGtmTrackingCode(environment.gtmId);
    }
  })
  .catch((err) => console.log(err));

const appendGtmTrackingCode = (gtmID) => {
  // LoggerService.log('Inside appendGtmTrackingCode');
  try {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmID}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmID}" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
    document.body.appendChild(noscript);

    const script1 = document.createElement('script');
    script1.innerHTML = `
       window.dataLayer = window.dataLayer || [];

       window.dataLayer.push({
          'event': 'Pageview',
          'url': '${document?.location?.origin}${document?.location?.pathname}'
      });
     `;
    document.head.appendChild(script1);
  } catch (ex) {
    /*console.error('Error appending google tag manager');
    console.error(ex);*/
  }
};
